import { useI18n } from "i18n";
import { useUpdateDisableVPNCheck } from "modules/companySettings";
import { selectMyCompany } from "modules/company/redux/selectors";
import { useSelector } from "react-redux";
import { isTrialCompleted } from "modules/companyPlanSettings/utils/trial";
import { useCompanyPlanSettings } from "modules/companyPlanSettings";
import { useTheme } from "@remo-co/ui-core/src/hooks/useTheme";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Switch } from "@remo-co/ui-core/src/components/Switch";
import { FormControlLabel } from "@remo-co/ui-core/src/components/FormControlLabel";
import { selectDisableVPNCheck } from "modules/companySettings/redux/selectors";
import { useStyles } from "./styles";

const Geartest = () => {
  const company = useSelector(selectMyCompany);
  const disableVPNCheck = useSelector(selectDisableVPNCheck);
  const { myCompanyPlan } = useCompanyPlanSettings();
  const { updateDisableVPNCheck } = useUpdateDisableVPNCheck(company?._id);
  const styles = useStyles();
  const theme = useTheme();
  const { t } = useI18n("settings");

  const onToggleClick = () => {
    updateDisableVPNCheck(!disableVPNCheck);
  };

  return (
    <Box marginBottom={theme.spacing(8)}>
      <Typography variant="h3">{t("geartest.settings")}</Typography>
      <Typography variant="body2" className={styles.subtitle}>
        {t("changes.event")}
      </Typography>
      <FormControlLabel
        label={t("disable.vpn.check")}
        labelPlacement="start"
        classes={{
          label: styles.label,
        }}
        control={
          <Switch
            color="primary"
            checked={disableVPNCheck}
            onChange={onToggleClick}
            testId="disable-vpn-check-switch"
            disabled={isTrialCompleted(myCompanyPlan)}
          />
        }
      />
    </Box>
  );
};

export default Geartest;
